module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEqSURBVHgB7ZXtTcMwEIZtJ//pBoQJcJIBaDdghDIBZYLCBDBCGIEJWhZIwgSYDTpBwnPgSEm/5Er5VfWVLlHuzu99SHmt1R7keV61bWtVIMitsae6rtfxgYRPbKICobW22MpaO9NqBEC0MMa80sRa95zSUYKFdOYYz/UdWZZ9y/m/kdnZI+zPgWQdQdE0jext0/fHBOaQvWEb9lCEkJE7JXeOJXzOBoTY0ielVVW5EEK/nhWE0zRNrzn308WM+t/bzk6OwY/55Ru56ceMGhkXwgvhWRLGaiSgPC9o4mQ0Qv7vQt4ysvzowTrYAaW52ueP5YIRGUIXl7T94QscRRRFd5y7x5w0NyiEtiVywXixPBUPZVkWA0J5CCkLXVDxNoSF4o5p3uXa3I79AtYrgE8uJ7RIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/blank.png
// module id = R6Vn
// module chunks = 46